var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['badge text-white', _vm.variant]},[_vm._v("\n  "+_vm._s(_vm.status)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }